define("shared/components/shared/ui/search-box/result", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li class="tSC--dropBody__item" ...attributes>
    <a class="tSC--dropBody__link" onclick={{action @onSelectAction @result}}>
      <div class="tSC--dropBody__linkText u--ellipsis">
        {{! Keyword }}
        {{#if @result.keyword}}
          {{@result.keyword}}
        {{/if}}
        {{! Industry }}
        <span
          class="tSC--dropBody__linkText--meta u--float--right u--text--light u--text--sm
            {{if @result.keyword 'class--right'}}"
        >
          {{@result.name}}
        </span>
      </div>
    </a>
  </li>
  */
  {
    "id": "3XvND58p",
    "block": "[[[11,\"li\"],[24,0,\"tSC--dropBody__item\"],[17,1],[12],[1,\"\\n  \"],[10,3],[14,0,\"tSC--dropBody__link\"],[15,\"onclick\",[28,[37,0],[[30,0],[30,2],[30,3]],null]],[12],[1,\"\\n    \"],[10,0],[14,0,\"tSC--dropBody__linkText u--ellipsis\"],[12],[1,\"\\n\"],[41,[30,3,[\"keyword\"]],[[[1,\"        \"],[1,[30,3,[\"keyword\"]]],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,1],[15,0,[29,[\"tSC--dropBody__linkText--meta u--float--right u--text--light u--text--sm\\n          \",[52,[30,3,[\"keyword\"]],\"class--right\"]]]],[12],[1,\"\\n        \"],[1,[30,3,[\"name\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@onSelectAction\",\"@result\"],false,[\"action\",\"if\"]]",
    "moduleName": "shared/components/shared/ui/search-box/result.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});